
<ng-template #attente>
  <br>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div *ngIf="!generaleService.disabled;else attente"></div>

  <img [src]="mainImage.File_Content" width="150px" (click)="openFrmImage('ajouter')">
  <mat-form-field>
    <input matInput name="Art_Des4" [(ngModel)]="facebook" placeholder="Facebook" >
  </mat-form-field>
  <mat-form-field>
    <input matInput name="Art_Des4" [(ngModel)]="instagram" placeholder="Instagram" >
  </mat-form-field>
  <mat-form-field>
    <input matInput name="Art_Des4" [(ngModel)]="tweeter" placeholder="Tweeter" >
  </mat-form-field>
    <button (click)="ajouter()" [disabled]="generaleService.disabled" mat-raised-button
      class="colorGreen">Ajouter</button>
    <button (click)="modifier()" [disabled]="generaleService.disabled" mat-raised-button
      class="colorGreen">Modifier</button>
    <button (click)="supprimer()" [disabled]="generaleService.disabled" mat-raised-button
      class="colorReed">Supprimer</button>
  
<div class="display-flex">
  <div class="txt">
    <angular-editor [config]="editorConfig2" name="tex5" placeholder="Employées Fr" [(ngModel)]="EmpFr">
    </angular-editor>
  </div>
  <div class="txt">
    <angular-editor [config]="editorConfig2" name="tex6" placeholder="Employées En" [(ngModel)]="EmpEn">
    </angular-editor>
  </div>
</div>

<div  class="display-flex">
  <div *ngFor="let img of listeImages"  class="image-content">
    <img [id]="img.File_Id" (click)="selectImage(img)" [src]="img.File_Content" width="100%"><br>
    <button (click)="openFrmImage('modifier',img)" [disabled]="generaleService.disabled" mat-raised-button
    class="colorGreen">Modifier</button>
  </div>
</div>
<input id="input_file" type="file" style="display: none;" value="importer" name="fghjk" (change)="onChangeImagefile($event)">